export const HOME = 'home'
export const PASSWORD = 'password'
export const OTP = 'otp'
export const AGREEMENT = 'agreement'
export const PRIVACY = 'privacy'
export const BASE_MENU = [
    {
        order: 1,
        title: 'Home',
        route: 'home',
        icon: 'HomeIcon'
    },
    {
        order: 2,
        title: 'Password',
        route: 'password',
        icon: 'KeyIcon'
    },
    {
        order: 3,
        title: 'OTP',
        route: 'otp',
        icon: 'LinkIcon'
    },
    {
        order: 4,
        title: 'Agreement',
        route: 'agreement',
        icon: 'CheckCircleIcon'
    },
    {
        order: 5,
        title: 'Privacy',
        route: 'privacy',
        icon: 'LockIcon'
    }
]

export const BASE_SERVICES = {
    /* default: {
        order: 1,
        title: 'Home',
        route: 'home',
        icon: 'HomeIcon'
    } */
}
export const PROVIDED_SERVICES = {
    /* default: {
        order: 1,
        title: 'Home',
        route: 'home',
        icon: 'HomeIcon'
    } */
}
